import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { SeoService,HelperService } from './core/services';
import { Location, LocationStrategy } from '@angular/common';
import { isPlatformBrowser, isPlatformServer } from
  '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'hayti';
  setMetaTags: any;
  sub: any;


  constructor(private titleService: Title,private HelperSvc: HelperService,
    private metaService: Meta,location: Location, private locationStrategy: LocationStrategy,
    private router: Router, private seoService: SeoService,  

    private activatedRoute: ActivatedRoute,   @Inject(PLATFORM_ID) private platform: Object) {
      // this.HelperSvc.loadRouting();

  //   this.PutJquery()
  // }
  // PutJquery() {
  //   if (isPlatformBrowser(this.platformId)) {
  //     // var authData = $.cookie('data');
  //   }
  // console.log("this.current url", location)
  // console.log(this.locationStrategy.getBaseHref());
  this.router.events.pipe(
    filter(e => e instanceof NavigationEnd),
    map(e => this.activatedRoute),
    map((route) => {
      while (route.firstChild) route = route.firstChild;
      return route;
    }),
    filter((route) => route.outlet === 'primary'),
    mergeMap((route) => route.data),
  ).subscribe(data => {
    let seoData = data['seo'];
    // console.log("in this", seoData)
    if (seoData) {
      // this.seoService.updateTitle(seoData['title']);
      this.titleService.setTitle(seoData['title']);
    }
    // this.seoService.updateMetaTags(seoData['metaTags']);
  });
  this.router.events
  .pipe(filter(event => event instanceof NavigationEnd))
  .subscribe((event: NavigationEnd) => {
    let currentUrl = this.router.url;
    if(!currentUrl.includes('/podcasts-web')){
      this.HelperSvc.changeAudioData('');  //invoke new Dat
      this.HelperSvc.setAudioPlayerList('');
      this.loadScript();
    }
  });
  }

  public loadScript() {
    var scripts = document.getElementsByTagName("script");
    var head = document.getElementsByTagName('head')[0];
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('id') != null && (scripts[i].getAttribute('id').includes("musicPlayer") )) {
        head.removeChild(scripts[i]);
      }
    }
  
  }



  setDocTitle(title: string) {
    // console.log('current title:::::' + this.titleService.getTitle());
    // this.titleService.setTitle(title);
  }
  // ngOnInit(){
  // this.
  // router.events.pipe(
  //   filter((event:any)=> event instanceof NavigationEnd),
  // )
  // .subscribe(()=>{
  //   var route = this.getChild(this.activatedRoute)
  //   var data = route.snapshot.data;
  //   // console.log("come-output",data);
  //   this.titleService.setTitle(data.title);
  //   if (data.descrption){
  //     this.metaService.updateTag({ name:'description', content:'data.descrption'})
  //   }else{
  //     this.metaService.removeTag("name='description'")
  //   }
  // })
  // }
  // getChild(activatedRoute: ActivatedRoute): any {
  //   if (activatedRoute.firstChild)
  //     return this.getChild(activatedRoute.firstChild);
  //   else
  //     return activatedRoute;
  // }
  ngOnInit() {
    // console.log("location",location.protocol )
  // if (isPlatformBrowser(this.platform)) {
  //   if (location.protocol === 'http:') {
  //     window.location.href = location.href.replace('http', 'https');
  //   }
  // }
    // this.router.events.pipe(
    //   filter(e => e instanceof NavigationEnd),
    //   map(e => this.activatedRoute),
    //   map((route) => {
    //     while (route.firstChild) route = route.firstChild;
    //     return route;
    //   }),
    //   filter((route) => route.outlet === 'primary'),
    //   mergeMap((route) => route.data),
    // ).subscribe(data => {
    //   let seoData = data['seo'];
    //   console.log("in this", seoData)

    //   this.seoService.updateTitle(seoData['title']);
    //   // this.seoService.updateMetaTags(seoData['metaTags']);
    // });
  }




}
